import apiClient from '@u/apiClient'

export default {
  fetchArtisanCommands({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/sa-management/command-runner/commands`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchCommandRuns({}, { source } = {}) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/sa-management/command-runner/runs`, { params: source ? { source } : {} })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  createCommandRun({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/sa-management/command-runner/runs`, payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  deleteCommandRun({ commit }, { run_id }) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`/sa-management/command-runner/runs/${run_id}`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTasks({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/sa-management/command-runner/schedule`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  runScheduledTaskNow({}, { command }) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/sa-management/command-runner/schedule/run`, { command })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchImportSources({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/sa-management/command-runner/import-sources`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchTenantDumps({}, { tenantId }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/sa-management/command-runner/tenant-dumps`, { params: { tenant_id: tenantId } })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  }
}